var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.info.show,
      "top": "10px",
      "close-on-click-modal": false,
      "append-to-body": true,
      "width": "450px"
    },
    on: {
      "update:visible": function ($event) {
        return _vm.$set(_vm.info, "show", $event);
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('tagName.editTagName')) + " "), _c('span', {
    staticClass: "gray"
  }, [_vm._v(_vm._s(_vm.$t('tagName.tagInfo')))])]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "nickname"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('tagName.tagName')) + ":")]), _c('el-input', {
    attrs: {
      "maxlength": 32,
      "placeholder": _vm.$t('tagName.add')
    },
    model: {
      value: _vm.tagName,
      callback: function ($$v) {
        _vm.tagName = $$v;
      },
      expression: "tagName"
    }
  })], 1)]), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "cancel",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.deleteFn
    }
  }, [_vm._v(_vm._s(_vm.$t('tagName.del')))]), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.tagName || (_vm.tagName.replace(/(^\s*)|(\s*$)/g, '') ? false : true)
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t('tagName.sub')))])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };